// Send logs to dev server terminal
function sendToServer(level: string, message: string, args: unknown[]): void {
  // Only send in browser environment
  if (typeof window === 'undefined') {
    return;
  }

  // Send to dev server endpoint (fire and forget)
  fetch('/__dev_logs__', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({
      level,
      message,
      args: args.map(arg => {
        try {
          return JSON.stringify(arg);
        } catch {
          return String(arg);
        }
      }),
      timestamp: new Date().toISOString(),
    }),
  }).catch((err) => {
    // Log fetch errors to browser console for debugging
    console.error('[Logging] Failed to send log to server:', err);
  });
}

export function log(message: string, ...args: unknown[]): void {
  console.log(`[Courtyard] ${message}`, ...args);
  sendToServer('log', message, args);
}

export function logInfo(message: string, ...args: unknown[]): void {
  console.info(`[Courtyard] ${message}`, ...args);
  sendToServer('info', message, args);
}

export function logWarn(message: string, ...args: unknown[]): void {
  console.warn(`[Courtyard] ${message}`, ...args);
  sendToServer('warn', message, args);
}

export function logError(message: string, ...args: unknown[]): void {
  console.error(`[Courtyard] ${message}`, ...args);
  sendToServer('error', message, args);
}

